<script setup lang="ts">
interface SidenavHeaderProps {
    title?: string
    showCloseButton?: boolean
    closeAriaLabel?: string
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<SidenavHeaderProps>(), {
    title: '',
    showCloseButton: true,
    closeAriaLabel: 'Close'
})

const emit = defineEmits<{
    close: []
}>()

const handleClose = () => {
    emit('close')
}
</script>

<template>
    <header class="relative flex items-center justify-center p-2 px-10 border-b border-border md:h-[100px] min-h-14">
        <div class="absolute left-3 md:left-6">
            <FoundationButton
                v-if="showCloseButton"
                :aria-label="closeAriaLabel"
                square
                @click="handleClose"
            >
                <FoundationIcon name="x" size="lg" />
            </FoundationButton>
        </div>

        <FoundationHeadline
            tag="h2"
            class="text-base font-bold"
            :level-style="false"
        >
            <!-- Use slot if provided, otherwise use title prop -->
            <slot>{{ title }}</slot>
        </FoundationHeadline>
    </header>
</template>
